import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AccountsService } from '../../../core/services/accounts.service';
import { OrdersService } from '../../../core/services/orders.service';
import { IntegToLicenseCrossreference } from '../../../core/interfaces/integrations';
import { Account } from '@mitel/cloudlink-sdk';

@Component({
  selector: 'absent-integ-notifier',
  templateUrl: './absent-integ-notifier.component.html',
  styleUrls: ['./absent-integ-notifier.component.scss']
})

export class AbsentIntegNotifierComponent implements OnChanges {
  @Input() account: Account;
  @Input() externalStyles: any = {};
  @Input() productTags: any;

  showAlerts: boolean = false;
  integAlertList = [];
  errMsgStyle: any = undefined;
  
  constructor(
    private accountService: AccountsService,
    private ordersService: OrdersService ) { }

  async ngOnChanges(changes: SimpleChanges)
	{
		if (changes.account && changes.account.currentValue) {
			this.account = changes.account.currentValue;
      this.integAlertList = [];
      this.showAlerts = false;
      await this.determineIfThereAreAbsentIntegrations();
    }

    if (changes.productTags && changes.productTags.currentValue) {
			this.productTags = changes.productTags.currentValue;
      if ( this.account ) // only if there is an account set
      {
        this.showAlerts = false;
        this.integAlertList = [];
        await this.determineIfThereAreAbsentIntegrations();
      }
    }
  }

  async determineIfThereAreAbsentIntegrations()
  {
    if ( this.account )
    {
      let prime = await this.accountService.isPartnerPrimeAccount();
      // do not check if this is a prime account
      if ( prime === true )
        return;

      let accountTags = [];
      
      try {
        let tags = await this.accountService.getAccountTagsById( this.account.accountId );
        if ( tags && tags.products ){
          accountTags = tags.products;
        }
      }
      catch(err)
      {
        // assuming no tags
      }
      // we are not going to make expensive billing calls if there is nothing worth querying
      // lets looks for missing integration that can have licenses
      let checkLicenses: string[] = [];

      // look to determine if we have that integration already
      // if we don't add it to the list to be check for licenses
      for ( var i = 0; i < IntegToLicenseCrossreference.length; i++ )
      {
        let isFound = accountTags.find( tagItem => {
          return IntegToLicenseCrossreference[i].integProductCode == tagItem;
        });
        if ( !isFound )
        {
          IntegToLicenseCrossreference[i].licenseNameInBilling.forEach( item => {
            checkLicenses.push(item);
          });
        }

      }

     
      if ( checkLicenses.length > 0 )
      {
        // We have licenses to check for
        // we are assuming we are already in assumed role state
        try {
          let licenses = await this.ordersService.getExistingActiveSubscriptionsSpecifiedForCustomerAccount( checkLicenses );
          if ( licenses && licenses.length > 0 )
          {
            this.integAlertList = [];
            this.showAlerts = false;
            for ( var i = 0; i < licenses.length; i++ )
            {
              for ( var j = 0; j < IntegToLicenseCrossreference.length; j++ )
              {
                for ( var k = 0; k < IntegToLicenseCrossreference[j].licenseNameInBilling.length; k++ )
                { 
                  if ( IntegToLicenseCrossreference[j].licenseNameInBilling[k] == licenses[i] )
                  {
                    this.integAlertList.push(IntegToLicenseCrossreference[j].integProductCode);
                    this.showAlerts = true;
                  }
                }
              }
            }
          }
          else{
            this.integAlertList = [];
            this.showAlerts = false;
          }
        }
        catch( err )
        {
        }

      }
      else{
          this.integAlertList = [];
          this.showAlerts = false;
      }
      
    }
  }
}